import type { NavChild } from '@assessments/shared'
import { NavLockIcon } from './NavLockIcon.js'

interface Props {
  items: NavChild[]
  activeIndex?: number | null
}

// `.nav-dropdown` panel: fixed 650px card with the Platform's layered shadow.
const panel = 'w-[650px] overflow-hidden rounded-md bg-surface shadow-panel'
const label = 'mb-1 font-jakarta text-base font-semibold text-heading'
const desc = 'text-sm text-muted'

export function NavDropdown({ items, activeIndex = null }: Props) {
  return (
    <div className={panel}>
      <div className="py-3">
        {items.map((child, index) =>
          child.state === 'disabled' ? (
            <div
              key={`${child.href}::${child.label}`}
              className="block cursor-not-allowed px-6 py-2 opacity-60"
            >
              <div className={cnLabelLocked}>
                {child.label}
                <NavLockIcon />
              </div>
              {child.description && <div className={desc}>{child.description}</div>}
            </div>
          ) : (
            <a
              key={`${child.href}::${child.label}`}
              href={child.href}
              target={child.target}
              rel={child.target === '_blank' ? 'noopener noreferrer' : undefined}
              aria-current={index === activeIndex ? 'page' : undefined}
              // pl-[22px] keeps the label aligned with its siblings once the 2px bar lands.
              className={
                index === activeIndex
                  ? 'group/link block border-l-2 border-highlight bg-surface-hover py-2 pl-[22px] pr-6 no-underline'
                  : 'group/link block px-6 py-2 no-underline'
              }
            >
              <div className={`${label} group-hover/link:underline`}>{child.label}</div>
              {child.description && <div className={desc}>{child.description}</div>}
            </a>
          ),
        )}
      </div>
    </div>
  )
}

const cnLabelLocked = `${label} inline-flex items-center`
